import { render, staticRenderFns } from "./Exclusions.vue?vue&type=template&id=494fa452&"
import script from "./Exclusions.vue?vue&type=script&lang=js&"
export * from "./Exclusions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports